import React, { useMemo } from 'react';
import { Skeleton, Stack, Typography } from '@mui/material';
import { roundToTwoDecimals } from 'utils/fomatting';

export enum StatType {
  Candidates,
  Satisfied,
  Delivered,
  Responded,
  NotInterested,
  OptedOut,
  NotDelivered
}

const formatPercentage = (value: number) => {
  if (!value) return `0%`;

  // cap at 100%
  if (value > 1) value = 1;
  return `${roundToTwoDecimals(value * 100)}%`;
};

type Props = {
  value: number;
  type: StatType;
  index: number;
  isLoading?: boolean;
};

export const CampaignStat: React.FC<Props> = ({
  value,
  type,
  index,
  isLoading
}) => {
  const textByType = useMemo(() => {
    if (type === StatType.Candidates) return 'Candidates';
    if (type === StatType.Satisfied) return 'Satisfied';
    if (type === StatType.Delivered) return 'Delivered';
    if (type === StatType.Responded) return 'Responded';
    if (type === StatType.NotInterested) return 'Not interested';
    if (type === StatType.OptedOut) return 'Opted out';
    if (type === StatType.NotDelivered) return 'Not delivered';
  }, [type]);

  const valueToDisplay = useMemo(() => {
    switch (type) {
      case StatType.Delivered:
      case StatType.Responded:
      case StatType.NotInterested:
      case StatType.OptedOut:
      case StatType.NotDelivered:
        return formatPercentage(value);

      default:
        return value; // for Candidates and Satisfied (count)
    }
  }, [value, type]);

  return (
    <Stack
      direction="column"
      alignItems="flex-start"
      paddingTop="15px"
      paddingX="15px"
      borderTop="1px solid"
      borderColor={index < 2 ? 'primary.main' : 'customGrey.dark'}
      mr={index === 1 ? '17px' : 0}
      flex={1}
      gap="5px"
    >
      {isLoading ? (
        <>
          <Skeleton variant="text" width={60} height={36} />
          <Skeleton variant="text" width={80} height={24} />
        </>
      ) : (
        <>
          <Typography fontWeight={600} fontSize="24px" color="customGrey.dark">
            {valueToDisplay}
          </Typography>
          <Typography variant="body1" color="customGrey.dark">
            {textByType}
          </Typography>
        </>
      )}
    </Stack>
  );
};
